// new values should be reflected in benchling/dev_platform/resources/eln/entries.py:_structured_table_to_attributes
// TODO(BNCH-107073): Remove and replace all usage with DG enum
enum InventoryStructuredTableMode {
  CREATE = 'CREATE', // Create and fill new containers, doesn't support well plates
  FILL = 'FILL', // Transfer into existing containers (and plate wells)
  LEGACY_TRANSFER = 'LEGACY_TRANSFER', // Transfer samples (legacy)
  UPDATE_CONTAINERS = 'UPDATE_CONTAINERS',
}

export default InventoryStructuredTableMode;

export enum InventoryTableInsertionTableType {
  TRANSFER = 'NEW_TRANSFER', // New transfer table
  LEGACY_TRANSFER = 'LEGACY_TRANSFER', // Legacy transfer table
  UPDATE_CONTAINERS = 'UPDATE_CONTAINERS', // New inventory (update container attributes) table
}
